<template>
    <!-- Each icon must provide its own view box -->
    <span>
        <template v-if="iconIsNotSvg">
            <component
                :is="iconName"
                :width="width"
                :height="height"
            />
        </template>
        <template v-else>
            <svg xmlns="http://www.w3.org/2000/svg"
                :width="width"
                :height="height"
                :aria-labelledby="iconName"
                role="presentation"
            >
                <title :id="iconName" lang="en">
                    {{ iconName }} icon
                </title>
                <g>
                    <!-- <slot /> -->
                    <component :is="iconName" />
                </g>
            </svg>
        </template>
    </span>
</template>

<script>
import Amazon from './icons/IconAmazon'
import Behance from './icons/IconBehance'
import Deviantart from './icons/IconDeviantart'
import Dribbble from './icons/IconDribbble'
import Etsy from './icons/IconEtsy'
import Facebook from './icons/IconFacebook'
import Flickr from './icons/IconFlickr'
import Instagram from './icons/IconInstagram'
import Kickstarter from './icons/IconKickstarter'
import Linkedin from './icons/IconLinkedIn'
import Medium from './icons/IconMedium'
import Pinterest from './icons/IconPinterest'
import Quora from './icons/IconQuora'
import Reddit from './icons/IconReddit'
import Scribd from './icons/IconScribd'
import Shutterstock from './icons/IconShutterstock'
import Slack from './icons/IconSlack'
import Snapchat from './icons/IconSnapchat'
import Soundcloud from './icons/IconSoundcloud'
import Spotify from './icons/IconSpotify'
import Tumblr from './icons/IconTumblr'
import Twitter from './icons/IconTwitter'
import Vimeo from './icons/IconVimeo'
import Whatsapp from './icons/IconWhatsapp'
import Wikipedia from './icons/IconWikipedia'
import Wordpress from './icons/IconWordpress'
import Yelp from './icons/IconYelp'
import Youtube from './icons/IconYoutube'

export default {
    components: {
        Amazon,
        Behance,
        Deviantart,
        Dribbble,
        Etsy,
        Facebook,
        Flickr,
        Instagram,
        Kickstarter,
        Linkedin,
        Medium,
        Pinterest,
        Quora,
        Reddit,
        Scribd,
        Shutterstock,
        Slack,
        Snapchat,
        Soundcloud,
        Spotify,
        Tumblr,
        Twitter,
        Vimeo,
        Whatsapp,
        Wikipedia,
        Wordpress,
        Yelp,
        Youtube
    },
    props: {
        iconName: {
            type: String,
            default: 'box'
        },
        width: {
            type: [Number, String],
            default: 18
        },
        height: {
            type: [Number, String],
            default: 18
        },
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    },
    computed: {
        iconIsNotSvg: function () {
            const nonSvgIcons = [
                'instagram',
                'soundcloud'
            ]
            return nonSvgIcons.includes(this.iconName)
        }
    }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
